import * as Types from '../types-api.generated';

import { CollectionFragment } from '../api-fragments.generated';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUpdateCollectionVariables = Types.Exact<{
  data: Types.ApiUpdateCollectionInput;
}>;


export type ApiUpdateCollection = { updateCollection: { id: string, contractAddress: string, symbol: string, name: string, slug: string | null, description: string | null, collectionImageUrl: string | null, coverImageUrl: string | null, createdAt: string, updatedAt: string } | null };



export const ApiUpdateCollectionDocument = /*#__PURE__*/ `
    mutation UpdateCollection($data: UpdateCollectionInput!) {
  updateCollection(data: $data) {
    ...CollectionFragment
  }
}
    ${CollectionFragment}`;

export const useUpdateCollection = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiUpdateCollection, TError, ApiUpdateCollectionVariables, TContext>) => {
    
    return useMutation<ApiUpdateCollection, TError, ApiUpdateCollectionVariables, TContext>(
      {
    mutationKey: ['UpdateCollection'],
    mutationFn: (variables?: ApiUpdateCollectionVariables) => apiFetcher<ApiUpdateCollection, ApiUpdateCollectionVariables>(ApiUpdateCollectionDocument, variables)(),
    ...options
  }
    )};


useUpdateCollection.fetcher = (variables: ApiUpdateCollectionVariables, options?: RequestInit['headers']) => apiFetcher<ApiUpdateCollection, ApiUpdateCollectionVariables>(ApiUpdateCollectionDocument, variables, options);
